// extracted by mini-css-extract-plugin
export var hidden = "_nd-1";
export var visible = "_nd-0";